import { render, staticRenderFns } from "./ConnectCoinbaseCustody.vue?vue&type=template&id=411673cc&"
import script from "./ConnectCoinbaseCustody.vue?vue&type=script&lang=js&"
export * from "./ConnectCoinbaseCustody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports